// src/components/ServicesPageSection.jsx
import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import {
 
  FaUniversity,
  FaHospital,
  FaNetworkWired,
  FaShoppingCart,
  FaChalkboardTeacher,
  FaShippingFast,
} from "react-icons/fa";
import "./ServicesPageSection.css"; // ✅ updated CSS file name

// Import service images
import service1 from "../assets/project-00.jpg";
import service2 from "../assets/project-11.jpg";
import service3 from "../assets/project-22.jpg";
import service4 from "../assets/project-33.jpg";
import service5 from "../assets/project-44.jpg";
import service6 from "../assets/project-55.jpg";

const services = [
 
  // ✅ New Services
  {
    title: "Government & Public Sector",
    desc: "Digital governance, smart city initiatives",
    img: service1,
    icon: <FaUniversity />,
  },
  {
    title: "Healthcare",
    desc: "Hospital IT systems, patient record management, secure infrastructure",
    img: service2,
    icon: <FaHospital />,
  },
  {
    title: "Telecommunications",
    desc: "Fiber-to-the-Home (FTTH), enterprise connectivity",
    img: service3,
    icon: <FaNetworkWired />,
  },
  {
    title: "Retail & E-Commerce",
    desc: "POS integrations, CRM, customer analytics",
    img: service4,
    icon: <FaShoppingCart />,
  },
  {
    title: "Education & Training",
    desc: "Digital learning platforms, secure networks",
    img: service5,
    icon: <FaChalkboardTeacher />,
  },
  {
    title: "Trade & Supply Chain",
    desc: "Sourcing, procurement, and cross-border trade solutions",
    img: service6,
    icon: <FaShippingFast />,
  },
];

const ServicesPageSection = () => {
  return (
    <section className="sp-services-section py-5">
      <Container>
        <Row className="mb-4">
          <Col md={8}>
            <h2 className="fw-bold">We Provide Superior project management Services</h2>
           <p>
  Effective project management ensures that goals are achieved within scope, time, 
  and budget. It involves planning, organizing, and managing resources to bring 
  successful outcomes. From defining clear objectives and timelines to tracking 
  progress and mitigating risks, project management helps teams collaborate, stay 
  focused, and deliver quality results for stakeholders.
</p>

            <Button className="sp-btn-red">VIEW ALL SERVICES</Button>

          </Col>
        </Row>
        <Row>
          {services.map((service, index) => (
            <Col md={4} className="mb-4" key={index}>
              <Card
                className={`sp-service-card ${
                  service.highlight ? "sp-highlight" : ""
                }`}
              >
                <div className="sp-service-img">
                  <img src={service.img} alt={service.title} className="img-fluid" />
                  <div className="sp-service-icon">{service.icon}</div>
                  <div className="sp-service-text">
                    <h5>{service.title}</h5>
                    <p>{service.desc}</p>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ServicesPageSection;
